import HeapClient from './client/heap-client';

const TRACKER_LABEL_PREFIX = 'tracking-';

export default class Tracker {
    /**
     * Create tracker.
     * @param scope - the tracker scope.
     * For component it maybe is component name.
     * For horizon it maybe is the module name.
     * @param client - the tracking client.
     * @param isTracking - is tracking flag.
     */
    constructor({ scope, client, isTracking = true }) {
        if (!scope) {
            throw new Error(
                'The tracker must have scope, please use your intlNamespace as your component tracking domain.'
            );
        }
        if (!client) {
            throw new Error(
                'The tracker must have a client to send the tracking infos.'
            );
        }
        this._client = client;
        this._scope = TRACKER_LABEL_PREFIX + scope;
        this._isTracking = isTracking;
        this._userId = null;
        this._instId = null;
    }

    set scope(scope) {
        if (scope) {
            this._scope = TRACKER_LABEL_PREFIX + scope;
        }
    }

    get scope() {
        return this._scope;
    }

    set isTracking(isTracking) {
        this._isTracking = !!isTracking;
    }

    get isTracking() {
        return this._isTracking;
    }

    /**
     * Generate custom property.
     * @param propertyName
     * @returns {string | null}
     */
    generateCustomProperty(propertyName) {
        if (this._isTracking === false) {
            return null;
        }
        if (propertyName) {
            return `${this._scope}-${propertyName}`;
        }
        return null;
    }

    /**
     * Track the event.
     * @param eventName
     * @param details
     */
    trackEvent({ eventName, details }) {
        if (this._isTracking === false) {
            return;
        }
        if (eventName && details) {
            this._client.track(`${this._scope}-${eventName}`, details);
        } else {
            // TODO: We should print the log.
        }
    }

    /**
     * Set user id.
     * @param userId
     */
    setUserId({ userId }) {
        if (this._isTracking === false) {
            return;
        }
        if (userId && userId !== this._userId) {
            this._userId = userId;
            // This special cases, because heap io already use userId as the identify for anonymous user.
            // see: https://docs.heap.io/reference#userid-and-identity.
            if (this._client instanceof HeapClient) {
                this._client.setIdentify(userId);
            }
        } else {
            // TODO: We should print the log.
        }
    }

    /**
     * Set inst id.
     * @param instId
     */
    setInstId({ instId }) {
        if (this._isTracking === false) {
            return;
        }
        if (instId && instId !== this._instId) {
            this._instId = instId;
            this._client.addUserProperty('instId', instId);
        } else {
            // TODO: We should print the log.
        }
    }
}
